/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_TimecodeInputs */

const en_new_timecode = /** @type {(inputs: New_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New timecode`)
};

const fr_new_timecode = /** @type {(inputs: New_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau timecode`)
};

const de_new_timecode = /** @type {(inputs: New_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Timecode`)
};

const it_new_timecode = /** @type {(inputs: New_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo codice temporale`)
};

const ru_new_timecode = /** @type {(inputs: New_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новый таймкод`)
};

const es_new_timecode = /** @type {(inputs: New_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo código de tiempo`)
};

const zh_cn2_new_timecode = /** @type {(inputs: New_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新时间码`)
};

const ja_new_timecode = /** @type {(inputs: New_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいタイムコード`)
};

const hi_new_timecode = /** @type {(inputs: New_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया टाइमकोड`)
};

const pt_pt2_new_timecode = /** @type {(inputs: New_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo código de tempo`)
};

/**
* | output |
* | --- |
* | "New timecode" |
*
* @param {New_TimecodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_timecode = /** @type {((inputs?: New_TimecodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_TimecodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_timecode(inputs)
	if (locale === "de") return de_new_timecode(inputs)
	if (locale === "it") return it_new_timecode(inputs)
	if (locale === "ru") return ru_new_timecode(inputs)
	if (locale === "es") return es_new_timecode(inputs)
	if (locale === "zh-CN") return zh_cn2_new_timecode(inputs)
	if (locale === "ja") return ja_new_timecode(inputs)
	if (locale === "hi") return hi_new_timecode(inputs)
	if (locale === "pt-PT") return pt_pt2_new_timecode(inputs)
	return en_new_timecode(inputs)
});